module.exports = __webpack_public_path__ + "img/schedule.0ce122b8.svg";